import { configureStore } from '@reduxjs/toolkit';

import rootReducer from '../reducers/reducers';

// Redux Toolkit v2 includes redux-thunk in the default middleware, so it no
// longer needs to be added explicitly (the old `middleware: [thunk]` array is
// also no longer a valid value — middleware must be a Tuple/callback).
export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production',
});

// https://github.com/reduxjs/redux-toolkit/issues/587
